import React, { useState, useEffect } from 'react';
import download from '../images/download.png';
import '../css/NavbarSecond.css';
import Table from './Table';
import DataSlider from './DataSlider';
//import Form from './Form';
import axios from 'axios'
import CustomAlert from './CustomeAlert';

function NavbarSecond() {
  const [distrct, setDistrict] = useState([]);
  const [taluka, setTaluka] = useState([]);
  const [village, setVillage] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [alertData, setAlertData] = useState({ show: false, message: '' });


  useEffect(() => {
    // Fetch dropdown data from backend
    const fetchData = async () => {
      const response = await fetch('https://checkmateelection.com/ramshinde/selecte.php');
      const jsonData = await response.json();
      setDistrict(jsonData);
    };
    fetchData();
  }, []);

  const handleDistrictChange = (e) => {
    const district = e.target.value;
    setSelectedDistrict(district);
    setSelectedTaluka(""); // Reset Taluka
    setSelectedVillage("")
   
    setVillage([]); // Reset Villages

    // Fetch Talukas for selected district
    axios.get(`https://checkmateelection.com/ramshinde/selecte.php?district=${district}`)
      .then(response => setTaluka(response.data))
      .catch(error => console.error("Error fetching talukas:", error));
  };

  const handleTalukaChange = (e) => {
    const taluka = e.target.value;
    setSelectedTaluka(taluka);

    // Fetch Villages for selected taluka
    axios.get(`https://checkmateelection.com/ramshinde/selecte.php?district=${selectedDistrict}&taluka=${taluka}`)
      .then(response => setVillage(response.data))
      .catch(error => console.error("Error fetching villages:", error));
  };


  const excelDownload = () => {
    axios({
      url: `https://checkmateelection.com/ramshinde/admin/exceltable.php?district=${selectedDistrict}`,
      method: 'GET',
      responseType: 'blob', // Ensure file download
    })
      .then(response => {
        // Convert Blob to text to check for error message
        response.data.text().then(text => {
          if (text.includes("No data found")) {           
            setAlertData({ show: true, message: 'No data found. Please try with a different district.' });
          } else {
            // Proceed with downloading the file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data.xlsx'); // Adjust filename
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        });
      })
      .catch(error => console.error("Error downloading Excel:", error));
  };
  
  
 

  // Handle day change and reset summary
 

  return (
    <>
    <CustomAlert show={alertData.show}
        message={alertData.message}
        onClose={() => setAlertData({ show: false, message: '' })}/>
      <div className="container-fluid justify-content-start d-flex gap-2 mt-2 nav p-2">
        <form action="" onSubmit={(e) => e.preventDefault()} className="form-inline my-2 my-lg-0">
          {/*<div className="buttons container-flex d-flex justify-content-start gap-3 ">
            <button
              className="btn btn-x btn-info"
              onClick={() => handleDayChange(1)}
              style={{ height: '20%' }}
            >
              Voting Done
            </button>
            <button
              className="btn btn-x btn-warning"
              onClick={() => handleDayChange(0)}
              style={{ height: '20%' }}
            >
              Pending Vote
            </button>
            <button
              className="btn btn-x btn-success"
              onClick={() => handleDayChange(-1)}
              style={{ height: '20%' }}
            >
              All Record
            </button>
          </div>*/}
        </form>

        <div className="buttons container-flex d-flex justify-content-center gap-3">
        <select className="select nav-item" value={selectedDistrict} onChange={handleDistrictChange}>
                <option value="">जिल्हा निवडा</option>
                {distrct.map(d => <option key={d.District_English} value={d.District_English}>{d.District_Marathi}</option>)}
              </select>
          <select className="select nav-item"  value={selectedTaluka} onChange={handleTalukaChange} disabled={!selectedDistrict}>
              <option value="">तालुका निवडा</option>
                {taluka.map(t => <option key={t.Taluka_English} value={t.Taluka_English}>{t.Taluka_Marathi}</option>)}
              </select>
            
            <select className="select nav-item" value={selectedVillage} onChange={(e) => setSelectedVillage(e.target.value)} disabled={!selectedTaluka}>
              <option value="">गाव निवडा</option>
                {village.map(v => <option key={v.Village_English} value={v.Village_English}>{v.Village_Marathi}</option>)}
              </select>

          
          <button
            className="btn btn-light btn-y d-flex justify-content-center"
            style={{ color: 'black' }}
            onClick={excelDownload}
            
          >
            <img
              src={download}
              alt="not found"
              style={{ width: '20px', height: '20px' }}
            />{' '}
            Excel
          </button>
        </div>
      </div>

      {<DataSlider district={selectedDistrict||"0"} />}
      {/*<Form booth={option} />*/}
       {<Table district={selectedDistrict||"0"} taluka={selectedTaluka} village={selectedVillage} />}
    </>
  );
}

export default NavbarSecond;
